// removed by extract-text-webpack-plugin
module.exports = {"content":"users__content-1o-Qr blocks__content--MOaB","usersList":"users__usersList-2pNXQ","user":"users__user-1PxBA"};


//////////////////
// WEBPACK FOOTER
// ./components/account/users/users.css
// module id = 785
// module chunks = 0